export default __webpack_public_path__ + "static/tn-0706223ea0c62af51b3f63fc2dc4a11c.svg";